<template>
       
    <div> {{msg}}</div>
</template>
<style></style>
<script>
    export default {
      name:'code-login',
        data() {
            return {msg: '扫码登录'}
        }
    }
</script>
